import { render } from "./DesktopLogin.vue?vue&type=template&id=07501188&scoped=true"
import script from "./DesktopLogin.vue?vue&type=script&lang=js"
export * from "./DesktopLogin.vue?vue&type=script&lang=js"

import "./DesktopLogin.vue?vue&type=style&index=0&id=07501188&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07501188"]])

export default __exports__